import { mdiAccountCheckOutline, mdiAccountOffOutline } from '@mdi/js';
import {
  StatusIcon, TCurrency, TEditUser, TLocation, TPhone,
} from '../../../types';

const STATUS_ICONS: StatusIcon = {
  active: {
    icon: mdiAccountCheckOutline,
    color: 'rgb(16 185 129 / 1)',
    text: 'memberRegistered',
  },
  pending: {
    icon: mdiAccountOffOutline,
    color: 'rgb(245 158 11 / 1)',
    text: 'pendingRegistration',
  },
};

const MEMBER_FIELDS = [
  'department',
  'position',
  'name',
  'email',
  'locations',
  'currency',
  'shopifyId',
  'timeoffLimit',
  'sickLeaveLimit',
  'pinCode',
  'commissionPlan',
];

const INITIAL_FORM: TEditUser = {
  position: '',
  department: 'Management',
  firstName: '',
  lastName: '',
  email: '',
  phone: {} as TPhone,
  paymentAmount: 0,
  paymentType: 0,
  locations: [] as Array<TLocation>,
  currency: {} as TCurrency,
  permissionLevel: 0,
  shopifyId: '',
  sickLeaveLimit: 0,
  timeoffLimit: 0,
  pinCode: '',
  commissionPlan: null,
  clockIn: {
    pos: true,
    web: true,
    mobile: true,
  },
  commissionTags: [] as TEditUser['commissionTags'],
  isPromoterCommission: false,
};

export {
  STATUS_ICONS,
  MEMBER_FIELDS,
  INITIAL_FORM,
};
